import type { PropsWithChildren } from "react";

type PDFAnnotationItemActionsProps = PropsWithChildren;

export function PDFAnnotationItemActions({
  children,
}: PDFAnnotationItemActionsProps) {
  return (
    <span className="af-absolute af-right-1 af-top-1 af-flex af-items-center af-gap-1 af-rounded af-opacity-0 af-transition-opacity group-hover:af-opacity-100">
      {children}
    </span>
  );
}
